<template>
    <b-card no-body >
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info">
                <b-icon icon="search" aria-hidden="true"></b-icon>
                Filtro de busqueda
            </b-button>
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
                <b-card-text>
                    <b-row>        
                        <b-col cols="12" md="4">
                            <label for="pedidoId">Identificador</label>
                            <b-form-input id="pedidoId" v-model="filter.pedidoId" @keydown.enter.prevent="$emit('get-pedidos')" placeholder="Identificador"></b-form-input>
                        </b-col>                    
                        <b-col cols="12" md="4">
                            <label for="vendedor">Vendedor</label>
                            <b-form-input id="vendedor" v-model="filter.vendedor" @keydown.enter.prevent="$emit('get-pedidos')" placeholder="vendedor"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="cliente">Nombre cliente</label>
                            <b-form-input id="cliente" v-model="filter.cliente" @keydown.enter.prevent="$emit('get-pedidos')" placeholder="Nombre cliente"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="nit">Nit Cliente</label>
                            <b-form-input id="nit" v-model="filter.nit" @keydown.enter.prevent="$emit('get-pedidos')" placeholder="Nit Cliente"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="departamento">Departamento</label>
                                <b-form-group>
                                    
                                <b-form-select
                                v-model="filter.departamento"
                                :options="departamentosList"
                                id="departamento"
                                class="mb-3"
                                value-field="id"
                                text-field="nombre"
                                @change="$emit('get-ciudades-list')"
                                >
                                <template #first>
                                    <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                </template>
                                </b-form-select>
                            </b-form-group>
                            <!--
                            <b-form-input id="departamento" v-model="filter.departamento" @keydown.enter.prevent="$emit('get-pedidos')" placeholder="Departamento"></b-form-input>
                            -->
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="ciudad">Ciudad</label>
                            <b-form-group>
                                    
                                <b-form-select
                                v-model="filter.ciudad"
                                :options="ciudadesList"
                                id="ciudad"
                                class="mb-3"
                                value-field="id"
                                text-field="nombre"
                                >
                                <template #first>
                                    <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                </template>
                                </b-form-select>
                            </b-form-group>
                            <!--
                            <b-form-input id="ciudad" v-model="filter.ciudad" @keydown.enter.prevent="$emit('get-pedidos')" placeholder="Ciudad"></b-form-input>
                            -->
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="date-from">Desde</label>
                            <b-form-datepicker placeholder="Seleccione Desde" id="date-from" v-model="filter.dateFrom"></b-form-datepicker>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="date-to">Hasta</label>
                            <b-form-datepicker id="date-to" v-model="filter.dateTo"></b-form-datepicker>
                        </b-col>
                        <b-col cols="12" md="12">
                            <div >
                                <b-button variant="info" @click.prevent="$emit('get-pedidos')" class="mx-1">
                                    <b-icon icon="search" aria-hidden="true"></b-icon>
                                    Buscar
                                </b-button>
                                <b-button variant="warning" @click.prevent="$emit('clear-filter-form')" class="mx-1 text-white">
                                    <b-icon icon="backspace" aria-hidden="true"></b-icon>
                                    Limpiar
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-text>
            </b-card-body>
        </b-collapse>
    </b-card>
    
</template>

<script>
export default {
    name: "FilterForm",
    props: {
        filter: {
            type: Object
        },
        departamentosList: {
            type: Array
        },
        ciudadesList: {
            type: Array
        }
    }
};

</script>
<style scoped>

</style>